import { createFeatureSelector, createSelector } from '@ngrx/store';

import { IUserSession } from '@shared/types/session';

const selectSessionFeature = createFeatureSelector<IUserSession>('session');

const selectAuth = createSelector(selectSessionFeature, (state) => ({
    isAuthenticated: state.isAuthenticated,
    user: state.user,
}));

const selectUserToken = createSelector(selectSessionFeature, (state) => {
    return state.token;
});

const selectUser = createSelector(selectSessionFeature, (state) => {
    return state.user;
});

const selectUserRoles = createSelector(selectSessionFeature, (state) => {
    return state.user.roles;
});

const selectUserCompanyRoles = createSelector(selectSessionFeature, (state) => {
    return state.companyRoles;
});

const selectIsAuth = createSelector(selectSessionFeature, (state) => {
    return state.isAuthenticated;
});

const selectCompanies = createSelector(selectSessionFeature, (state) => {
    return state.companies;
});

const selectCompanyId = createSelector(selectSessionFeature, (state) => {
    return state.currentCompanyId;
});

const selectIsIframeMode = createSelector(selectSessionFeature, (state) => {
    return state.isIframeMode;
});

const selectShowCompanySelector = createSelector(selectSessionFeature, (state) => state.showCompanySelector);

const selectAccessTokenSet = createSelector(selectSessionFeature, (state) => state.accessTokenSet);

const selectSessionReady = createSelector(selectSessionFeature, (state) => state.session_ready);

const selectPermissions = createSelector(selectSessionFeature, (state) => state.userPermissions);

const selectSessionState = createSelector(selectSessionFeature, (state) => state);

const selectUserLang = createSelector(selectSessionFeature, (state) => state.user.preferred_language);

export {
    selectSessionFeature,
    selectAuth,
    selectUserToken,
    selectUser,
    selectUserRoles,
    selectIsAuth,
    selectCompanies,
    selectCompanyId,
    selectIsIframeMode,
    selectShowCompanySelector as showCompanySelector,
    selectAccessTokenSet,
    selectSessionReady,
    selectPermissions,
    selectSessionState,
    selectUserLang,
    selectUserCompanyRoles,
};
